import { render, staticRenderFns } from "./assertList.vue?vue&type=template&id=2d0ab595&scoped=true"
import script from "./assertList.vue?vue&type=script&setup=true&lang=js"
export * from "./assertList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./assertList.vue?vue&type=style&index=0&id=2d0ab595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0ab595",
  null
  
)

export default component.exports